import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Header from '../../../common/Header';
import TicketBanner from '../../../common/TicketBanner';


function FlightTicketBanner() {
  return (
    <>
      {/*<Sidebar />*/}
      <div className="main-content vh-100 vh_md-auto overflow-y-a">
        <Header title="Flight" />
        {/* CARDS */}
        <div className="container-fluid">
          <div className="row">
            <nav className="mb-5">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">
                    <i className="fe fe-home"></i> Dashboard
                  </Link>
                </li>
                <Link to={"/ticket/flight/booking"} className="breadcrumb-item active" aria-current="page">
                Flight Booking
                </Link>
                <li className="breadcrumb-item active" aria-current="page">
                Carousel
                </li>
              </ol>
            </nav>
            <hr />
              <TicketBanner type={"flight"}/>
       
          </div>
        </div>
      </div>
    </>
  )
}

export default FlightTicketBanner